const dashboardDetailMock = [
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'Philip',
    lastNames: 'Lubin',
    id: '12345678',
    age: '80',
    insuranceCarrier: 'Aliansalud',
    sgateTFG: '5',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'Maren',
    lastNames: 'Lipshutz',
    id: '12345678',
    age: '82',
    insuranceCarrier: 'Compensar',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'Jordyn',
    lastNames: 'George',
    id: '12345678',
    age: '74',
    insuranceCarrier: 'Sura',
    sgateTFG: '3b',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'James',
    lastNames: 'Stanton',
    id: '12345678',
    age: '56',
    insuranceCarrier: 'Sanitas',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'James',
    lastNames: 'Lubin',
    id: '12345678',
    age: '71',
    insuranceCarrier: 'Compensar',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Julio',
    names: 'Ahmad',
    lastNames: 'Dorwart',
    id: '12345678',
    age: '56',
    insuranceCarrier: 'Sanitas',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Medio',
    risk: 'Medio',
    month: 'Julio',
    names: 'Lindsey',
    lastNames: 'Dorwart',
    id: '12345678',
    age: '71',
    insuranceCarrier: 'Compensar',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Medio',
    risk: 'Medio',
    month: 'Julio',
    names: 'Jordyn',
    lastNames: 'Saris',
    id: '12345678',
    age: '56',
    insuranceCarrier: 'Sanitas',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Medio',
    risk: 'Medio',
    month: 'Julio',
    names: 'Dulce',
    lastNames: 'Ekstrom Bothman',
    id: '12345678',
    age: '71',
    insuranceCarrier: 'Compensar',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'Philip',
    lastNames: 'Lubin',
    id: '12345678',
    age: '80',
    insuranceCarrier: 'Aliansalud',
    sgateTFG: '5',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'Maren',
    lastNames: 'Lipshutz',
    id: '12345678',
    age: '82',
    insuranceCarrier: 'Compensar',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'Jordyn',
    lastNames: 'George',
    id: '12345678',
    age: '74',
    insuranceCarrier: 'Sura',
    sgateTFG: '3b',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'James',
    lastNames: 'Stanton',
    id: '12345678',
    age: '56',
    insuranceCarrier: 'Sanitas',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Agosto',
    names: 'James',
    lastNames: 'Lubin',
    id: '12345678',
    age: '71',
    insuranceCarrier: 'Compensar',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Alto',
    risk: 'Alto',
    month: 'Julio',
    names: 'Ahmad',
    lastNames: 'Dorwart',
    id: '12345678',
    age: '56',
    insuranceCarrier: 'Sanitas',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Medio',
    risk: 'Medio',
    month: 'Julio',
    names: 'Lindsey',
    lastNames: 'Dorwart',
    id: '12345678',
    age: '71',
    insuranceCarrier: 'Compensar',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Medio',
    risk: 'Medio',
    month: 'Julio',
    names: 'Jordyn',
    lastNames: 'Saris',
    id: '12345678',
    age: '56',
    insuranceCarrier: 'Sanitas',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  },
  {
    badgeRisk: 'Medio',
    risk: 'Medio',
    month: 'Julio',
    names: 'Dulce',
    lastNames: 'Ekstrom Bothman',
    id: '12345678',
    age: '71',
    insuranceCarrier: 'Compensar',
    sgateTFG: '4',
    TFG: '10%',
    kidneyUnit: '',
    TFG2009: '',
    stageTFG2009: '',
    modality: '',
    therapy: ''
  }
];

export default dashboardDetailMock;
